import React from 'react'

import { CHART_SEGMENT_CONTROL_CLEARANCE_X } from './ChartSegmentControl'

interface ChartSegmentTitleSlotProps {
  children: React.ReactNode
  contentPadRight?: number
  style?: React.CSSProperties
  /**
   * Slides that already had a test id on the header this slot replaces pass it
   * here, so the slot keeps their DOM shape (one div, same siblings) instead of
   * nesting an extra wrapper. Layout assertions use the data attribute below.
   */
  testId?: string
}

export function ChartSegmentTitleSlot(props: ChartSegmentTitleSlotProps) {
  const { children, contentPadRight = 0, style, testId } = props
  // The reservation is the control's full hovered width, not its resting 44px box: the
  // pill unfurls leftward over this row, which is how it came to print over the
  // matrix-rating scale swatches. One helper, so a new slide type inherits it.
  const extra = Math.max(0, CHART_SEGMENT_CONTROL_CLEARANCE_X - contentPadRight)

  return (
    <div
      data-testid={testId ?? 'chart-segment-title-slot'}
      data-chart-segment-title-slot="true"
      data-content-pad-right={String(contentPadRight)}
      style={{
        minWidth: 0,
        boxSizing: 'border-box',
        ...style,
        paddingRight: extra,
        overflow: 'hidden',
      }}
    >
      {children}
    </div>
  )
}

/**
 * The space between a bar chart's question heading and its bars, in a fixed-height
 * flex column. It is the one part of the panel that gives way: a question that wraps
 * to more lines takes its extra height from this gap, not from the bars below it.
 */
export function ChartHeadingGap({ height, minHeight }: { height: number; minHeight: number }) {
  return <div aria-hidden style={{ flex: `0 1 ${height}px`, minHeight }} />
}
